export function qsClearObject(keys) {
    if (!keys)
        return {};
    return keys.reduce((acc, key) => {
        acc[key] = '';
        return acc;
    }, {});
}
